import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { toast } from "@/lib/notices";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          { session_id: sessionId },
          { headers: { "X-Session-ID": sessionId } }
        );
        if (data?.session_token) {
          localStorage.setItem("ac_token", data.session_token);
        }
        setUser(data.user);
        toast.success("Signed in with Google");
        // Clean the hash and route
        window.history.replaceState({}, document.title, "/dashboard");
        navigate(data.user?.onboarded ? "/dashboard" : "/onboarding", { state: { user: data.user } });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 mx-auto border-2 border-sand border-t-brand rounded-full animate-spin mb-4" />
        <div className="text-sm text-stone-600">Signing you in…</div>
      </div>
    </div>
  );
}
